import React from "react";
import Layout from "@/components/layout";
import Footer from "@/components/footer";
import HeaderOneTop from "@/components/header-one-top";
import HeaderOne from "@/components/header-one";
import SearchContextProvider from "@/context/search-context";
import MenuContextProvider from "@/context/menu-context";
import NewsPage from "@/components/news-page";

const NewsListing = ({ location }) => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout PageTitle="Aktualności" description="Najnowsze aktualności Jagiellonia Białystok — transfery, wyniki, relacje z meczów i informacje klubowe." pathname={location.pathname}>
          <HeaderOneTop />
          <HeaderOne />
          <NewsPage />
          <Footer />
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  );
};

export default NewsListing;
